var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.848 10.3347L8.00956 0.55415C7.57168 -0.172943 6.42832 -0.196397 5.99044 0.55415L0.152013 10.3347C-0.285869 11.0618 0.273647 12 1.17374 12H12.8263C13.7264 12 14.2859 11.0853 13.848 10.3347ZM7.01216 8.29417C7.62033 8.29417 8.1312 8.78672 8.1312 9.37308C8.1312 9.9829 7.62033 10.452 7.01216 10.452C6.37967 10.452 5.89313 9.9829 5.89313 9.37308C5.89313 8.78672 6.37967 8.29417 7.01216 8.29417ZM5.94179 4.42416C5.91746 4.25998 6.06342 4.11925 6.23371 4.11925H7.76629C7.93658 4.11925 8.08254 4.25998 8.05822 4.42416L7.88793 7.61399C7.8636 7.77817 7.74197 7.87199 7.59601 7.87199H6.40399C6.25803 7.87199 6.1364 7.77817 6.11207 7.61399L5.94179 4.42416Z",
    fill: "#F38A00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.a4371a64bd804117c4d8417b8be74b55.svg";
export { ForwardRef as ReactComponent };